import React from 'react'
import { Link } from 'react-router-dom'

const Copyright = () => {
  return (
    <>
      <footer className='bg-darkblue py-2 text-center px-3'>
        <p className='my-2 text-white fw-semibold'>&copy; KCM Medical Store. All Rights Reserved. Developed By
          <Link to='https://www.digithack.in/' className='text-decoration-none text-white' target='_blank'> Digit Hack Software Solutions.</Link></p>
      </footer>
    </>
  )
}

export default Copyright
